export class Stopwatch {
    #startTime = 0;
    #elapsedTime = 0;
    #isRunning = false;
    #ratio = 1;
    #previousTime = 0;
    get isRunning() {
        return this.#isRunning;
    }
    start() {
        this.#isRunning = true;
        this.#elapsedTime = 0;
        this.#startTime = Date.now();
        this.#previousTime = this.#startTime;
    }
    resume() {
        if (this.#isRunning) {
            return;
        }
        this.#isRunning = true;
        this.#previousTime = Date.now();
    }
    reset() {
        this.#elapsedTime = 0;
        this.#startTime = Date.now();
        this.#previousTime = this.#startTime;
    }
    stop() {
        if (!this.#isRunning) {
            return;
        }
        this.#isRunning = false;
        this.#update();
    }
    getTime() {
        if (this.#isRunning) {
            this.#update();
        }
        return this.#elapsedTime;
    }
    setRatio(ratio) {
        if (ratio <= 0) {
            return;
        }
        if (this.#isRunning) {
            this.#update();
        }
        this.#ratio = ratio;
    }
    #update() {
        const currentTime = Date.now();
        this.#elapsedTime += (currentTime - this.#previousTime) * this.#ratio;
        this.#previousTime = currentTime;
    }
}
